import AccommodationsAndActivities from './AccommodationsAndActivities';

export default AccommodationsAndActivities;
